import { ptBR } from '@/i18n/pt-BR';
import type { PrecificacaoErrorReason } from '@/lib/precificacao';

/** Traduz o motivo estável do cliente para a mensagem pt-BR da tela. */
export function mapPrecificacaoError(reason: PrecificacaoErrorReason): string {
  switch (reason) {
    case 'conflict':
      return ptBR.precificacao.errorConflict;
    case 'not_found':
      return ptBR.precificacao.errorBancoInexistente;
    case 'validation':
      return ptBR.precificacao.errorValidation;
    case 'unauthorized':
      return ptBR.precificacao.errorUnauthorized;
    case 'network':
      return ptBR.precificacao.errorNetwork;
    default:
      return ptBR.precificacao.errorGeneric;
  }
}
